// project imports
import { getVisualDepth } from '../visualDepth';

// ==============================|| OVERRIDES - DIALOG TITLE ||============================== //
// Modal header: background, separator, padding. Applied app-wide.

export default function DialogTitle(theme) {
  const vd = getVisualDepth(theme);
  const sectionBorder = vd.dialogSectionBorder ?? (theme.palette.modal?.divider || 'rgba(0,0,0,0.24)');

  return {
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          fontSize: '1rem',
          fontWeight: 500,
          background: '#FAFAFA',
          borderBottom: `1px solid ${sectionBorder}`,
          padding: '24px 24px 16px 24px'
        }
      }
    }
  };
}
